module.exports = ".cot-udf-section-invalid, cot-udfs-regular-form-error {\n  color: red; }\n\n.cot-udf-section-error {\n  font-style: italic; }\n\n.cot-udf-heading {\n  text-transform: uppercase;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.87); }\n\n.cot-udf-label {\n  font-weight: bold; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/cot-udfs-regular-form/cot-udfs-regular-form.component.scss
// module id = ./src/app/widgets/cot-udfs-regular-form/cot-udfs-regular-form.component.scss
// module chunks = main